/**
 * Mapa centralizado de status de pagamento.
 * Use getPaymentStatusDisplay() em TODOS os componentes que exibem status de pagamento.
 */
export const PAYMENT_STATUS_MAP = {
  waiting_payment: {
    label: 'Aguardando pagamento',
    color: '#f59e0b',
    bgColor: '#fef3c7',
    icon: 'fa-clock',
    badge: 'warning',
  },
  processing: {
    label: 'Processando',
    color: '#3b82f6',
    bgColor: '#dbeafe',
    icon: 'fa-spinner',
    badge: 'info',
  },
  authorized: {
    label: 'Autorizado',
    color: '#8b5cf6',
    bgColor: '#ede9fe',
    icon: 'fa-check-circle',
    badge: 'secondary',
  },
  paid: {
    label: 'Pago',
    color: '#10b981',
    bgColor: '#d1fae5',
    icon: 'fa-circle-check',
    badge: 'success',
  },
  expired: {
    label: 'Expirado',
    color: '#6b7280',
    bgColor: '#f3f4f6',
    icon: 'fa-hourglass-end',
    badge: 'secondary',
  },
  refunded: {
    label: 'Reembolsado',
    color: '#f97316',
    bgColor: '#ffedd5',
    icon: 'fa-rotate-left',
    badge: 'warning',
  },
  cancelled: {
    label: 'Cancelado',
    color: '#ef4444',
    bgColor: '#fee2e2',
    icon: 'fa-ban',
    badge: 'danger',
  },
  failed: {
    label: 'Falhou',
    color: '#ef4444',
    bgColor: '#fee2e2',
    icon: 'fa-circle-xmark',
    badge: 'danger',
  },
};

/**
 * Retorna o objeto de display para um status de pagamento.
 * @param {string} status
 * @returns {{ label: string, color: string, bgColor: string, icon: string, badge: string }}
 */
export function getPaymentStatusDisplay(status) {
  return PAYMENT_STATUS_MAP[status] ?? {
    label: status ?? 'Desconhecido',
    color: '#6b7280',
    bgColor: '#f3f4f6',
    icon: 'fa-question-circle',
    badge: 'secondary',
  };
}

/**
 * Retorna true se o pagamento está em estado terminal (não muda mais).
 */
export function isPaymentTerminal(status) {
  return ['paid', 'expired', 'refunded', 'cancelled', 'failed'].includes(status);
}

/**
 * Retorna true se o pagamento está pendente de ação / ainda pode ser confirmado.
 */
export function isPaymentPending(status) {
  return ['waiting_payment', 'processing', 'authorized'].includes(status);
}
